import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VueHead from 'vue-head'

import VueCompositionApi, { provide } from "@vue/composition-api"

import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { DefaultApolloClient } from "@vue/apollo-composable";

import { provideStore } from './compositions/useStore'

import imagesLoaded from 'vue-images-loaded'

Vue.config.productionTip = false
Vue.use(VueCompositionApi)
Vue.use(VueHead)
Vue.directive('imagesLoaded', imagesLoaded)

Vue.filter('dateFormat', function (value) {
  let d = new Date(value)
  return `${(`0${d.getDate()}`).slice(-2)}.${(`0${(d.getMonth() + 1)}`).slice(-2)}.${d.getFullYear()}`
})

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_API_URL
})

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true
})

new Vue({
  setup(props, { root: { $store } }) {
    provideStore($store)
    provide(DefaultApolloClient, apolloClient)
  },
  store,
  router,
  render: h => h(App)
}).$mount('#app')